// extracted by mini-css-extract-plugin
export default {"signup":"Signup_signup__3+usb","text":"Signup_text__czQoy"};